import EconomicData from "@/model/EconomicData";
import FuelEconomicData from "@/model/FuelEconomicData";
import ParametricTableService from "./ParametricTableService";
import utils from "@/utils/configuration/config.js";
import CalcAttainedEEXIService from "./CalcAttainedEEXIService";

class CalcEconomicDataService {
  private static instance: CalcEconomicDataService;

  private constructor() {}

  private getAnnualConsumption(fuelData: FuelEconomicData) {
    fuelData.consumptionInTons = false;
    let result = fuelData.annualConsumption;
    if (fuelData.consumptionInTons) {
      const parametricTables: any = ParametricTableService.getInstance().getParametricTable(
        utils.config.firebaseConfig.parametricVersion
      );
      const parametricTablesObj = {
        fuelType: parametricTables.fuelType,
      };

      const lcv = CalcAttainedEEXIService.get_value_for_fuel_type(
        "LCV",
        fuelData.code,
        parametricTablesObj,
        new Array<string>()
      );
      result = (result * lcv) / 3600;
    }
    return result;
  }

  private fuelCostsPerYear(fuelEconomicData: Array<FuelEconomicData>, amortizationPeriod: number) {
    const result = new Array<number>();
    let year = 0;
    while (year < amortizationPeriod) {
      let totalAmount = 0;
      fuelEconomicData.forEach((fuelEconomicData) => {
        const annualConsumption = this.getAnnualConsumption(fuelEconomicData);
        const actualFuelPrice = annualConsumption * fuelEconomicData.price;
        totalAmount += actualFuelPrice + actualFuelPrice * ((fuelEconomicData.annualPriceIncrease / 100) * year);
      });
      year += 1;
      result.push(totalAmount);
    }
    return result;
  }

  public static getInstance(): CalcEconomicDataService {
    if (!this.instance) {
      this.instance = new CalcEconomicDataService();
    }
    return this.instance;
  }

  public calcEconomicData(economicData: EconomicData, configurationEEXI: number, baseEEXI: number) {
    const yearToCalcEconomicData = 20;

    const fuelCostsPerYearModified = this.fuelCostsPerYear(
      economicData.fuelEconomicDatasModified,
      yearToCalcEconomicData
    );
    const fuelCostsPerYearInitial = this.fuelCostsPerYear(
      economicData.fuelEconomicDatasInitial,
      yearToCalcEconomicData
    );

    const annualRentability = new Array<number>();
    const interestPerYear = new Array<number>();
    const vanPerYear = new Array<number>();
    const ecoEfficiency = new Array<number>();
    let year = 0;
    while (year < yearToCalcEconomicData) {

      let firstYearStopCosts = 0
      if (year == 0) {
        firstYearStopCosts = economicData.technicalStopDuration * economicData.dailyCosts
      }

      const vr =
        fuelCostsPerYearInitial[year] -
        fuelCostsPerYearModified[year] +
        (economicData.miscellaneousCostsInitial - economicData.miscellaneousCostsModified) - 
        firstYearStopCosts;

      const divisor: number = (1 as number) * 1 + (economicData.discountRate as number) * 1;
      const actualRentability = vr / Math.pow(divisor, year);
      // console.log(
      //   "Economic. Year = ",
      //   year,
      //   ". vr =",
      //   vr,
      //   ". Rentability =",
      //   actualRentability,
      //   ". DiscountRate =",
      //   economicData.discountRate,
      //   ". Divisor =",
      //   divisor
      // );
      annualRentability.push(actualRentability);

      if (year < economicData.amortizationPeriod) {
        const pendingCapital =
          economicData.amountToFinance - (economicData.amountToFinance * year) / economicData.amortizationPeriod;
        interestPerYear.push((pendingCapital * economicData.interestRate) / 100);
      } else {
        interestPerYear.push(0);
      }

      let year2 = 0;
      let vanSummatory = 0;
      while (year2 <= year) {
        vanSummatory += annualRentability[year2] - interestPerYear[year2];
        year2 += 1;
      }
      const vanActualYear = vanSummatory - economicData.amountToFinance;
      vanPerYear.push(vanActualYear);

      ecoEfficiency.push((baseEEXI - configurationEEXI) * (1 + vanActualYear / economicData.initialInvestment));

      year += 1;
    }

    // console.log("annualRentability", annualRentability);
    // console.log("interestPerYear", interestPerYear);
    // console.log("vanPerYear", vanPerYear);
    // console.log("ecoEfficiency", ecoEfficiency);

    economicData.annualRentability = annualRentability;
    economicData.interestPerYear = interestPerYear;
    economicData.vanPerYear = vanPerYear;
    economicData.ecoEfficiency = ecoEfficiency;

    return { annualRentability, interestPerYear, vanPerYear, ecoEfficiency };
  }
}

export default CalcEconomicDataService;
